import { Position } from '@cutr/constants/windows/windows';
import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router-dom';

import { usePositionStore } from '@/windows/api/positionStore';

import { getPositionQuery } from './crud';
import { useHydratePositionStore } from './mappers';

export const windowPositionLoader =
  (queryClient: QueryClient) =>
  async ({ params }: LoaderFunctionArgs) => {
    const { orderId, positionId } = params;
    const { id: storeId } = usePositionStore.getState();

    if (!orderId || !positionId) {
      throw new Error('Order ID and position ID are required');
    }

    const query = getPositionQuery(orderId, positionId);
    const hydrateStore = useHydratePositionStore();

    // cache hit
    const positionCache = queryClient.getQueryData<Position>(query.queryKey);
    if (positionCache) {
      if (positionId !== storeId) {
        hydrateStore(positionCache);
      }

      return positionCache;
    }

    const freshPosition = await queryClient.fetchQuery(query);
    hydrateStore(freshPosition);

    return freshPosition;
  };
